import React from "react";
import { FaStar, FaRegStar, FaUserCircle } from "react-icons/fa"; // Import star icons


const ReviewCard = ({ review }) => {
  const { author_name, profile_photo_url, text, rating } = review;

  // Function to render stars based on rating
  const renderStars = (rating) => {
    return Array.from({ length: rating }, (_, index) =>
      index < rating ? <FaStar key={index} className="star filled" /> : <FaRegStar key={index} className="star empty" />
    );
  };

  return (
    <div className="review-card">
      <div className="review-header">
        {profile_photo_url? <img src={profile_photo_url || "../user.png"} alt={author_name} className="reviewer-img"/>
        :<FaUserCircle className="default-icon" />}
        <h3 className="reviewer-name">{author_name}</h3>
        <p className="review-text">"{text}"</p>
      </div>
        <div className="stars">{renderStars(rating)}</div>
    </div>
  );
};

export default ReviewCard;
